import { DevelopmentDetailsQuery } from '@zoopla/listing-search-queries';

function capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getDevelopmentInfo = (
    data: DevelopmentDetailsQuery | undefined
): string[] => {
    const developmentAttributes: string[] = [];

    const listings = data?.newHomesDevelopmentData?.listingsDetails?.listings;

    if (!listings) {
        return developmentAttributes;
    }

    if (data?.newHomesDevelopmentData?.bedrooms) {
        developmentAttributes.push(data?.newHomesDevelopmentData?.bedrooms);
    }

    const firstListing = listings?.[0];

    const listingAttributes = [
        firstListing?.garden ? 'garden' : '',
        firstListing?.parking ? 'parking' : '',
        firstListing?.balcony ? 'balcony' : '',
        firstListing?.terrace ? 'terrace' : '',
        firstListing?.garage ? 'garage' : ''
    ].filter(Boolean);

    listingAttributes.length = Math.min(listingAttributes.length, 3);

    if (listingAttributes.length > 0) {
        const listingAttributeFormatter = new Intl.ListFormat('en', {
            style: 'long',
            type: 'conjunction'
        });
        const formattedAttributes = capitalizeFirstLetter(
            listingAttributeFormatter.format(listingAttributes)
        );

        developmentAttributes.push(formattedAttributes);
    }

    developmentAttributes.push('10 Year warranty');

    return developmentAttributes;
};
